import { ProcessCommissionsParameters } from "../ProcessCommissionsParameters";
import { ProcessCommissionsPost } from "../ProcessCommissionsPost";
import { Layout, Step, Stepper } from "@mcleod/components";

export abstract class AutogenLayoutProcessCommissionsStepper extends Layout {
    layoutParameters: ProcessCommissionsParameters;
    layoutProcessCommissionsPost: ProcessCommissionsPost;
    stepParameters: Step;
    stepPost: Step;
    stepSummaries: Step;
    stepperProcessCommissions: Stepper;
}
